import React, {useState, useEffect} from 'react';
import Axios from 'axios'
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import {TextCompare} from '../TextCompare/TextCompare'
import {NgramDisplay} from '../NgramDisplay/NgramDisplay'
import {VectorSimilarity} from '../VectorSimilarity/VectorSimilarity'
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import { ConvolutionMatches } from '../ConvolutionMatches/ConvolutionMatches'
// import NgramDisplay from '../NgramDisplay'

import { runQuery, textReduce } from '../utils'
import { getRelatedExpressions } from './queries'

import { useNodes } from '../XTextWrapper/NodeContext'

// Define props using an interface
interface MyComponentProps {
  // Define your prop types here
  selectionRange?: any,
  info: any,
  hidden?: boolean,
  surfaceWidth?: number,
  handleAddCtRelatedExpressions?: () => void,
  handleShowCollationOverlay?: () => void
  handleChangeInfo?: any
  handleUpdateCompareExpressionIds?: any
}

export const TextCompareWrapper: React.FC<MyComponentProps> = (props) => {
console.log("props.info.structureType", props.info.structureType)
  const [expressions, setExpressions] = useState<any[]>([])
  const [expressionsCumulative, setExpressionsCumulative] = useState<any[]>([])
  const [page, setPage] = useState<number>(1)
  const [intendedPage, setIntendedPage] = useState<number>(1)
  const [pagesize] = useState<number>(1000)
  const [nextPage, setNextPage] = useState<number>(2)
  const [previousPage, setPreviousPage] = useState<number | undefined>(undefined)
  // const [offset, setOffset] = useState<number>(0)
  // TODO; rangeStart and rangeEnd are confusing and possibly conflicting with wordRage Start and End
  //where as rangeStart and end here seem to be for page size
  const [rangeStart, setRangeStart] = useState<number>(1)
  const [rangeEnd, setRangeEnd] = useState<number>(10)
  const [baseText, setBaseText] = useState<string>("")
  const [customExpressionId, setCustomExpressionId] = useState<string>("")
  const [customExpressionObject, setCustomExpressionObject] = useState<any>()
  const [showAllChildren, setShowAllChildren] = useState<boolean>(false)
  const [showAllChildrenImages, setShowAllChildrenImages] = useState<boolean>(false)
  const [showNgram, setShowNgram] = useState<boolean>(false)
  const [showVector, setShowVector] = useState<boolean>(false)
  const [showTextComparison, setShowTextComparison] = useState<boolean>(true)
  const [showConvolution, setShowConvolution] = useState<boolean>(false)

  const { setItemRelatedExpressions } = useNodes();

  useEffect(() => {
    setCustomExpressionObject(null)
    setCustomExpressionId("")
    retrieveRelatedExpressions(props.info.resourceid, page, pagesize)
    getText(props.info.ctranscription)
  }, [props.info.resourceid, props.selectionRange?.wordRange?.start, props.selectionRange?.wordRange?.end, page]);


  const getText = (ctranscription: string) => {
        Axios.get("https://exist.scta.info/exist/apps/scta-app/csv-pct.xq?resourceid=" + ctranscription)
          .then((text) => {
            let reducedText = text.data;
                if (props.selectionRange?.wordRange){
                  const wordRange = props.selectionRange.wordRange.start + "-" + props.selectionRange.wordRange.end
                  reducedText = textReduce(text.data, wordRange)
                }
                setBaseText(reducedText)
            })
      }
      /**
       * @description initiates sparql requests and parses initial results.
       * @param {string} resourceid - scta url for expression object
       * @param {integer} page - page to start on in paging results
       * @param {integer} pagesize - length of page results
       */
      const retrieveRelatedExpressions = (resourceid: string, page: number, pagesize: number) => {
        const offset = (page - 1) * pagesize
        const rangeStart = (props.selectionRange && props.selectionRange.wordRange) ? props.selectionRange.wordRange.start : "" ;
        const rangeEnd = (props.selectionRange && props.selectionRange.wordRange) ? props.selectionRange.wordRange.end : "";
        //const queryString = getRelatedExpressions(resourceid, offset, pagesize, rangeStart, rangeEnd)
        const queryString = getRelatedExpressions(resourceid, offset, pagesize, rangeStart, rangeEnd)
        const relatedExpressions = runQuery(queryString)
        
        relatedExpressions.then((d) => {
          const bindings2 = d.data.results.bindings
          const expressionsArray: any[] = []
          // if target resource is NOT structureCollect, 
          // then add first object which should be compare item for first/target resource
          
            expressionsArray.push({
              id: props.info.resourceid,
              authorTitle: props.info.authorTitle,
              longTitle: props.info.longTitle,
              show: false
            });

          //arrange sparql results into an object with resourceids as keys
          bindings2.forEach((r: any) => {
            
            const element = r?.element?.value.split("/resource/")[1]
            const end = r?.isRelatedToRangeEnd?.value
            const start = r?.isRelatedToRangeStart?.value
            const isRelatedTo = r?.isRelatedTo?.value
            const wordRange = {start: parseInt(start), end: parseInt(end)}
            const type = r?.label?.value

            expressionsArray.push({
              id: r.isRelatedTo.value,
              relationLabel: r.label.value,
              referringResource: r.element ? r.element.value : "",
              author: r.author ? r.author.value : "",
              authorTitle: r.authorTitle ? r.authorTitle.value : "",
              longTitle: r.longTitle ? r.longTitle.value : "",
              show: false,
              isRelatedToRange: r.isRelatedToRangeStart && r.isRelatedToRangeEnd ? r.isRelatedToRangeStart.value + '-' + r.isRelatedToRangeEnd.value : "",
              parentBlock: r.parentBlock ? r.parentBlock.value : "",
              parentBlockTranscription: r.parentBlockTranscription ? r.parentBlockTranscription.value : "",
              text: "",
              wordRange, 
              selectedElementTargetId: element,
              isRelatedTo: isRelatedTo,
              isRelatedToTranscription: r.isRelatedToTranscription.value,
              type: type
    
            })
          })
          // set related expressions in NodeContext if setRelatedExpressions is defined
          // comment out if we want to set ngramMatches here; which we might want if we want the chat to use these as context
          setItemRelatedExpressions && setItemRelatedExpressions(expressionsArray)

          // set state with new related expressions results and updates to paging information
          // TODO setExpressions and setExpressions Cumulative should only 
          // run if the setRelatedExpressions from NodeContext is not defined
          setExpressions(expressionsArray)
          //setExpressionsCumulative(...expressionsCumulative,(expressionsArray))
          setIntendedPage(page)
          setNextPage(page + 1)
          setPreviousPage(page > 1 ? page - 1 : undefined)
          // setOffset((page - 1) * pagesize)
          setRangeStart(((page - 1) * pagesize) + 1)
          setRangeEnd(pagesize * page)
        })
        
      }

    const handleChangeBase = (rawText: string) => {
      setBaseText(rawText)
    }
    const handleCustomUpdateRelatedExpressions = (e: any) => {
          e.preventDefault()
          const expressionObject = {
            id: customExpressionId,
            relationLabel: "user added comparison"
          }
          setCustomExpressionObject(expressionObject)
        }
    const displayExpressions = () => {
      const combinedExpressions = customExpressionObject ? [...expressions, customExpressionObject] : expressions
      const displayExpressions = combinedExpressions.map((i: any, index: number) => {
        const isMainText = props.info.resourceid === i.id ? true : false
        return (
          <div key={index + "-" + i.id}>
            {<TextCompare
              info={props.info}
              expressionid={i.id}
              relationLabel={i.relationLabel}
              referringResource={i.referringResource}
              author={i.author}
              authorTitle={i.authorTitle}
              longTitle={i.longTitle}
              isMainText={isMainText}
              handleChangeBase={handleChangeBase}
              baseText={baseText}
              show={showAllChildren ? true : i.show}
              showImages={showAllChildrenImages ? true : i.show}
              surfaceWidth={props.surfaceWidth}
              isRelatedToRange={i.isRelatedToRange}
              targetRange={(props.selectionRange && props.selectionRange.wordRange) ? props.selectionRange.wordRange.start + "-" + props.selectionRange.wordRange.end : ""}
              handleAddCtRelatedExpressions={props.handleAddCtRelatedExpressions}
              handleShowCollationOverlay={props.handleShowCollationOverlay}
              handleChangeInfo={props.handleChangeInfo}
              handleUpdateCompareExpressionIds={props.handleUpdateCompareExpressionIds}
            />}
          </div>
        )
      })
      return displayExpressions
    }

    
    
    const displayPagination = () => {
      return (
        <div>
        {
          (Object.keys(expressions).length > pagesize || rangeEnd > pagesize) &&
        <p className="small">
          {previousPage &&
            <span>
              <span className="lbp-span-link" onClick={() => setPage(previousPage)}>Previous {previousPage}</span>  
              <span> | </span>
            </span>
              }
          <span>Current Page: </span>
          <FormControl style={{width: "40px", display: "inline"}} size="sm" id="text" type="text" onChange={(e: any) => {setIntendedPage(e.target.value)}} value={intendedPage}></FormControl>
          <Button style={{display: "inline"}} size="sm" onClick={() => {setPage(intendedPage)}}>Go</Button>
          
          <span>({rangeStart} - {rangeEnd})</span>
          {Object.keys(expressions).length > pagesize && 
            <span>
              <span> | </span> 
              <span className="lbp-span-link" onClick={() => {setPage(nextPage)}}>Next: {nextPage}</span>
            </span>
          }
        </p>
          }
        </div>
      )
    }

  return(
      <Container className={props.hidden ? "hidden" : "showing"}>
        <br />
        {!showTextComparison ? 
        <h6><span className="lbp-span-link" onClick={() => setShowTextComparison(true)}><FaEye/></span> Text Comparisons</h6>: 
        <>
        <h6><span className="lbp-span-link" onClick={() => setShowTextComparison(false)}><FaEyeSlash/></span> Text Comparisons</h6>
        <div>
            {displayPagination()}
            {/* <p className="small"><a href="https://lombardpress.org/adfontes/" target="_blank" rel="noopener noreferrer">Advanced Index and Filtering</a></p> */}
            <p className="small lbp-span-link" onClick={() => {setShowAllChildren(!showAllChildren)}}>Toggle All Children</p>
            {showAllChildren && <p className="small lbp-span-link" onClick={() => {setShowAllChildrenImages(!showAllChildrenImages)}}>Toggle All Children Images</p>}
            <hr />
            {displayExpressions()}
            <hr />
            {displayPagination()}
            <div style={{ "borderBottom": "1px solid rgba(0, 0, 0, 0.1)", padding: "5px" }}>
              <p style={{ fontSize: "12px" }}>Create custom user compare</p>
              <Form onSubmit={(e) => {handleCustomUpdateRelatedExpressions(e)}}>
                <FormControl size="sm" id="text" type="text" value={customExpressionId} placeholder="expression id" className="mr-sm-2" onChange={(e) => { setCustomExpressionId(e.target.value) }} />
                <Button size="sm" type="submit" style={{ margin: "2px" }}>Submit</Button>
              </Form>
            </div>
        </div>
        </>
        }
        <hr />
        {/* <hr />
        <div>
          <p>Other Comparison/Connection Visualizations</p>
          <p><a target="_blank" rel="noopener noreferrer" href={"http://lombardpress.org/collation-vizualizer/index.html?id=" + props.info.resourceid}>Collation Overlay</a></p>
          <p><span className="lbp-span-link" onClick={this.props.handleShowCollationOverlay}>Collation Table Overlay</span></p>
          <p><a target="_blank" rel="noopener noreferrer" href={"https://scta.github.io/networks-explorer/?resourceid=" + props.info.resourceid}>View Reference Connections</a></p>
          <p><a target="_blank" rel="noopener noreferrer" href={"https://scta.github.io/networks-explorer/topicconnections.html?resourceid=" + props.info.resourceid}>View Topic Connections</a></p>
        </div> */
        }
        
        {
        (props.info.structureType == "block") &&
        <>
        {!showNgram ? 
        <h6><span className="lbp-span-link" onClick={() => setShowNgram(true)}><FaEye/></span> Ngram Similarity</h6>: 
        <>
        <h6><span className="lbp-span-link" onClick={() => setShowNgram(false)}><FaEyeSlash/></span> Ngram Similarity</h6>
          <div>
            <NgramDisplay
              handleChangeBase={handleChangeBase}
              baseText={baseText}
              surfaceWidth={props.surfaceWidth}
              resourceid={props.selectionRange?.wordRange ? props.info.resourceid + "@" + props.selectionRange.wordRange.start + "-" + props.selectionRange.wordRange.end : props.info.resourceid}
              markedExpressions={expressions}
              handleAddCtRelatedExpressions={props.handleAddCtRelatedExpressions}
              handleShowCollationOverlay={props.handleShowCollationOverlay}
              handleChangeInfo={props.handleChangeInfo}
              />
          </div>
          </>
        }
        <hr />
        </>
        }
        
        
        
        {
        (props.info.structureType == "item" || props.info.structureType == "block" || props.info.structureType == "division") &&
        <>
        {!showVector ? 
          <h6><span className="lbp-span-link" onClick={() => setShowVector(true)}><FaEye/></span> Vector Similarity</h6>: 
          <>
            <h6><span className="lbp-span-link" onClick={() => setShowVector(false)}><FaEyeSlash/></span> Vector Similarity</h6>
            <div>
              <VectorSimilarity resourceid={props.info.resourceid.split("/resource/")[1]} handleChangeInfo={props.handleChangeInfo} structureType={props.info.structureType} baseText={baseText}/>
            </div>
          </>
        }
        <hr />
        </>
        }

        
        {
        (props.info.structureType == "item" || (props.info.structureType == "collection" && props.info.level == "1")) &&
        <>
        {!showConvolution ? 
          <h6><span className="lbp-span-link" onClick={() => setShowConvolution(true)}><FaEye/></span> Convolution Matches</h6>: 
          <>
            <h6><span className="lbp-span-link" onClick={() => setShowConvolution(false)}><FaEyeSlash/></span> Convolution Matches</h6>
            <div>
              <ConvolutionMatches expressionid={props.info.resourceid?.split("/resource/")[1]} displayType='count'/>
            </div>
          </>
        }
        </>
        }
        

        
        
      </Container>

    );
  }
